module.exports = __webpack_public_path__ + "static/media/requestStaff.f7728286.svg";